import { api } from "./api";

export const getTickets = () => {
    return api.get("/tick");
};

export const createTicket = async (body) => {
    return api.post("/tick/register", body);
}

export const editTicket = async (body) => {
    return api.put("/tick/updt", body);
}

export const editTicketStatus = async (body) => {
    return api.put("/tick/updt/interaction", body);
}

export const deleteTicket = async (id) => {
    return api.delete(`/tick/del/${id}`, )
}

export const getInteractions = async (id) => {
    return api.get(`/tick/${id}`)
}